import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";
import { FundraiserMeterWidget } from "./fundraiser-meter.js";

export class FundraiserBannerWidget extends Widget {
	getContribute() {
		const hostParts = window.location.hostname.split('.');
		const tld = hostParts[hostParts.length - 1] || 'com';
		return `https://accounts.talkingpointsmemo.${tld}/contribute`;
	}

	componentWillMount() {
		window.tpm_fb = this;
		this.showTotalContributors = true;
		this.state.totalContributors = undefined;

		
		const dismissed = getCookie("tpm_dismiss_fundraiser_components");
		if (dismissed) this.state.dismissed = true;
		this.toggleDismiss = this.toggleDismiss.bind(this);
		this.closeForever = this.closeForever.bind(this);
		this.remindLater = this.remindLater.bind(this);

	}

	setup(resp) {
		if (this.state.dismissed) return;
		this.setState({ totalContributors: resp.totalContributors });
	}

	toggleDismiss(e) {
		e.preventDefault();
		this.setState({
			dismissIntent: !this.state.dismissIntent,
		});
	}

	closeForever() {
		setCookie("tpm_dismiss_fundraiser_components", 1, 7);
		this.setState({
			dismissed: true,
		});
	}

	remindLater() {
		setCookie("tpm_dismiss_fundraiser_components", 1, 1);
		this.setState({
			dismissed: true,
		});
	}

	formattedNumber(num) {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	renderContent() {
		if (this.state.dismissed) return;

		if (this.state.dismissIntent) {
			return (
				<div className="FundraiserBanner__Inner --barely-blue">
					<div
						class="FundraiserBanner__Dismiss --back"
						onClick={this.toggleDismiss}
					>
						{/* <i class="fa-light fa-angle-left"></i> */}
						BACK
					</div>
					<div class="FundraiserBanner__DontSee">
						Don't want to see this ad?
					</div>
					<div class="FundraiserBanner__Buttons">
						<div
							onClick={this.remindLater}
							class="Button --red FundraiserBanner__Button --sm"
						>
							REMIND ME LATER
						</div>
						
						<div
							onClick={this.closeForever}
							class="Button --red FundraiserBanner__Button --sm"
						>
							<span class="hide-tiny">I </span>ALREADY CONTRIBUTED
						</div>
					</div>
				</div>
			);
		}

		if (this.showTotalContributors && !this.state.totalContributors) return;

		const contributeUrl = this.getContribute();


		return (
			<a
				className="FundraiserBanner__Inner"
				
				href={contributeUrl}
			>
				<div className="FundraiserBanner__Left">
					<div className="FundraiserLogo">
						<div class="underline"><span><span>The&nbsp;TPM</span></span></div>
						<div class="underline"><span><span>Journalism</span></span></div>
						<div class="underline"><span><span>Fund</span></span></div>
					</div>
				</div>
				<div className="FundraiserBanner__Center">
					<FundraiserMeterWidget meteronly={true} />
				</div>
				<div className="FundraiserBanner__Right">
					<div className="FundraiserBanner__RightText">
						Reader-supported <br/>not billionaire controlled
					</div>
					<div className="FundraiserBanner__RightButton">
						<a href={contributeUrl} class="Button --red ">CONTRIBUTE</a>
					</div>

				</div>
				<div class="FundraiserBanner__Dismiss" onClick={this.toggleDismiss}>
					<Icon name="xmark" style="sharp-light" />
				</div>
			</a>
		);
	}
}
